import { kml } from '@tmcw/togeojson';

const setAccessMap = () => {
  const processGeometry = (geometry, bounds) => {
    if (geometry instanceof google.maps.Data.Point) {
      bounds.extend(geometry.get());

    } else if (geometry instanceof google.maps.Data.MultiPoint) {
      geometry.getArray().forEach(point => {
        bounds.extend(point.get());
      });

    } else if (
      geometry instanceof google.maps.Data.LineString ||
      geometry instanceof google.maps.Data.LinearRing
    ) {
      geometry.getArray().forEach(latLng => {
        bounds.extend(latLng);
      });

    } else if (geometry instanceof google.maps.Data.MultiLineString) {
      geometry.getArray().forEach(line => {
        processGeometry(line, bounds);
      });

    } else if (geometry instanceof google.maps.Data.Polygon) {
      geometry.getArray().forEach(ring => {
        processGeometry(ring, bounds);
      });

    } else if (geometry instanceof google.maps.Data.MultiPolygon) {
      geometry.getArray().forEach(polygon => {
        processGeometry(polygon, bounds);
      });

    } else if (geometry instanceof google.maps.Data.GeometryCollection) {
      geometry.getArray().forEach(g => {
        processGeometry(g, bounds);
      });
    }
  }

  window.initMap = async () => {
    const map = new google.maps.Map(accessMap, {
      center: {
        lat: 35.681236,
        lng: 139.767125
      },
      zoom: 10,
    });
    // const data = await response.json();
    map.data.addGeoJson(mapData);

    const bounds = new google.maps.LatLngBounds();

    map.data.forEach(feature => {
      const geometry = feature.getGeometry();

      processGeometry(geometry, bounds);
    });

    map.fitBounds(bounds, 80);

    google.maps.event.addListenerOnce(map, "bounds_changed", () => {
      map.setZoom(Math.min(map.getZoom(), 18));
    });

    map.data.setStyle({
      icon: {
        url: accessMap.dataset.mapPin,
        scaledSize: new google.maps.Size(24, 33),
      },
    });

    const infoWindow = new google.maps.InfoWindow();

    const geocoder = new google.maps.Geocoder();
    map.data.addListener("click", (event) => {
      const name = event.feature.getProperty("name");

      geocoder.geocode(
        {
          location: event.latLng,
        },
        (results, status) => {
          if (status !== "OK" || !results.length) {
            console.error(status);
            return;
          }

          infoWindow.setContent(`
        <div>
          <strong>${name}</strong><br>
          ${results[0].formatted_address}
        </div>
      `);

          infoWindow.setPosition(event.latLng);
          infoWindow.open(map);
        }
      );
    });
  }

  const fetchMapGeoJSON = async () => {
    const kmlUrl =
      'https://www.google.com/maps/d/kml?forcekml=1&mid=1J5Uegeip-j4sWyxvKSq9ZYNCYEsOETs';

    const response = await fetch(kmlUrl);

    if (!response.ok) {
      throw new Error(`KML取得エラー: ${response.status}`);
    }

    const kmlText = await response.text();

    const parser = new DOMParser();
    const xml = parser.parseFromString(
      kmlText,
      'application/xml'
    );

    if (xml.querySelector('parsererror')) {
      throw new Error('KMLの解析に失敗しました');
    }

    return kml(xml);
  }

  const setAccessMapScript = async () => {
    const GOOGLE_MAP_API_KEY = 'AIzaSyCEoUhrFcRtOHFnvFGLBRyiRVu2phXLlME';
    // const GOOGLE_MAP_API_KEY = 'AIzaSyDpDzLbzvi92ysmeEfGycqiluR0iABktdI';

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&callback=initMap&loading=async`;
    script.async = true;
    script.defer = true;

    window.mapData = await fetchMapGeoJSON();

    document.head.appendChild(script);
  }

  const accessMap = document.getElementById("access-map");
  if (accessMap) {
    setAccessMapScript();
  }
};

export default setAccessMap;
